import React, { useEffect, useState } from "react";
import { Cookie } from "lucide-react";

const KEY = "pcb_cookie_consent";

export const CookieConsent = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) setShow(true);
  }, []);

  const decide = (choice) => {
    localStorage.setItem(KEY, JSON.stringify({ choice, at: new Date().toISOString() }));
    setShow(false);
  };

  if (!show) return null;

  return (
    <div
      data-testid="cookie-consent-banner"
      className="fixed inset-x-0 bottom-0 z-[60] px-4 pb-4"
    >
      <div className="mx-auto flex max-w-3xl flex-col gap-3 rounded-2xl border border-white/10 bg-slate-900/95 p-4 shadow-2xl backdrop-blur sm:flex-row sm:items-center sm:gap-4">
        <div className="flex items-start gap-3">
          <div className="rounded-xl bg-emerald-500/15 p-2"><Cookie className="h-5 w-5 text-emerald-400" /></div>
          <p className="text-xs leading-relaxed text-slate-300">
            We use cookies for essential functionality, login sessions, security and analytics.{" "}
            <a href="/cookie-policy" className="text-emerald-400 underline hover:text-emerald-300" data-testid="cookie-consent-policy-link">
              Learn more
            </a>.
          </p>
        </div>
        <div className="flex shrink-0 gap-2 sm:ml-auto">
          <button
            data-testid="cookie-consent-decline"
            onClick={() => decide("essential")}
            className="rounded-full border border-white/15 px-4 py-2 text-xs font-semibold text-slate-300 hover:bg-white/5"
          >
            Essential only
          </button>
          <button
            data-testid="cookie-consent-accept"
            onClick={() => decide("all")}
            className="rounded-full bg-emerald-500 px-4 py-2 text-xs font-semibold text-white hover:bg-emerald-400"
          >
            Accept all
          </button>
        </div>
      </div>
    </div>
  );
};
